import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col, Typography } from 'antd';
import {
  FormCancelButton,
  FormSaveButton,
} from 'common/components';
import { StyledModal } from 'common/components';
import { DEFAULT_STATE } from './CertificateTab';
import { formatMDY } from 'utils/formatDate';
import AgGridClientSide from 'common/components/ag-grid/AgGridClientSide';

const InfoModal = injectIntl((props) => {
  const { onInfoSubmit, setActionState, actionState, rowData, setShowInfoModal } = props;
  const [selectedIds, setSelectedIds] = useState([]);

  const handleSubmit = async (mode) => {
    onInfoSubmit &&
      onInfoSubmit({
        archiveCertificateIds: mode === 'archive' ? selectedIds : [],
      });
  };

  const onSelectionChanged = (params) => {
    const selectedRows = params.api.getSelectedRows();

    setSelectedIds(selectedRows.map((row) => row.id)); // Update selected IDs
  };

  const title = 'Select Certificate(s) to archive';
  const height = 550;

  const columnDefs = [
    { headerName: 'Certificate Name', field: 'certificateName' },
    { headerName: 'Certificate Type', field: 'certificateType' },
    {
      headerName: 'Location Name',
      field: 'associatedLocation',
      valueGetter: (params) => {
        return params.data.associatedLocation?.join(', ') || '';
      }
    },
    {
      headerName: 'Expiry Date',
      field: 'expirationDate',
      valueGetter: (params) => {
        return formatMDY(params.data.expirationDate) || '';
      }
    },
  ];

  return (
    <React.Fragment>
      <StyledModal
        title={title}
        width={800}
        destroyOnClose
        maskClosable={false}
        visible={actionState.visible}
        onCancel={() => setShowInfoModal(false)}
        bodyStyle={{ height }}
        onOk={handleSubmit}
        footer={[
          <FormCancelButton
            onClick={() => setShowInfoModal(false)}
          />,

          <FormSaveButton
            text='Archive and Continue'
            style={{ marginLeft: 10 }}
            onClick={() => handleSubmit('archive')}
            disabled={selectedIds.length === 0} // Disable if no rows are selected
          />,
          <FormSaveButton
            text='Continue without Archiving'
            style={{ marginLeft: 10 }}
            onClick={handleSubmit}
          />,
        ]}
      >
        <Row gutter={[8, 8]}>
          <Col span={24} style={{ marginBottom: '14px', marginTop: '15px' }}>
            <Typography.Title level={5}>
              There is existing certificate(s) of the same type. Please select the certificate(s)
              you want to archive before proceeding.
            </Typography.Title>
          </Col>

          <Col span={24}>
            <div className='member-tab-contacts__grid' style={{ height: '500px' }}>
              <AgGridClientSide
                rowData={rowData}
                columnDefs={columnDefs}
                includeCheckbox={true}
                onSelectionChanged={onSelectionChanged}
              />
            </div>
          </Col>
        </Row>
      </StyledModal>
    </React.Fragment>
  );
});

export default InfoModal;
